<template>
  <div>
    <v-layout wrap>
      <v-flex pa-2 pt-12 xs12 text-center>
        <span
          style="font-family:opensansextrabold;font-size:30px;color:#616161;"
        >Payment {{order.payment_status}}</span>
      </v-flex>
      <v-flex xs12>
        <span
          style="font-family:opensanssemibold;font-size:12px;color:#616161;"
        >Please don't go back of refresh this page while we redirect you.</span>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["id"],
  data() {
    return {
      order: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      var data = {};
      data["orderid"] = this.id;
      axios({
        method: "GET",
        url: "/payment/get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: data,
      })
        .then((response) => {
          this.order = response.data.data;
          setTimeout(() => {
            this.$router.push("/MyOrders");
          }, 5000);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>